module.exports = __webpack_public_path__ + "img/Group 120.2bd7dcef.jpg";